document.addEventListener('DOMContentLoaded', function() {
  const grid = document.querySelector('#product-grid');
  const loadMoreButton = document.querySelector('.load-more');
  if (!grid || !loadMoreButton) return;

  loadMoreButton.addEventListener('click', () => {
    const nextUrl = loadMoreButton.dataset.nextUrl;
    if (!nextUrl) return;

    loadMoreButton.textContent = 'Loading...';
    loadMoreButton.disabled = true;

    fetch(nextUrl)
      .then(res => res.text())
      .then(data => {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(data, 'text/html');
        const newProducts = htmlDoc.querySelectorAll('#product-grid .grid__item');
        const newButton = htmlDoc.querySelector('.load-more');

        newProducts.forEach(item => grid.appendChild(item));

        if (newButton) {
          loadMoreButton.dataset.nextUrl = newButton.dataset.nextUrl;
          loadMoreButton.textContent = 'Load More';
          loadMoreButton.disabled = false;
        } else {
          loadMoreButton.remove();
        }
      })
      .catch(err => {
        console.error('Error loading more products:', err);
        loadMoreButton.textContent = 'Error — Try Again';
        loadMoreButton.disabled = false;
      });
  });
});
